module.exports = __webpack_public_path__ + "static/media/pencil.9fdba113.svg";